import React from 'react';
import Api from '../../api';
import { onError } from '../../libs/error-lib';
import { useRefreshScore } from '../../libs/hooks-lib';
import { useAppContext } from '../../libs/context-lib';
import AllTeamsScoreBoard from 'boss-ui/src/containers/AllTeamsScoreBoard';

const API = new Api();


export default function ScoreBoard({ eventId }) {
  const { user } = useAppContext();
  return <AllTeamsScoreBoard eventId={eventId} api={API} useRefreshScore={useRefreshScore} onError={onError}
                             user={user} isAdmin={true} />;
}
